module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CompareButton":{"add":"Přidat k porovnání","active":"Žádný produkt k porovnání | {count} produkt k porovnání | Zobrazit {count} produkty k porovnání | Zobrazit {count} produktů k porovnání","remove":"Odebrat z porovnání"}}}')
  delete Component.options._Ctor
}
